query GetItemMetadata {
  itemMetadata {
    lastImportedAt
    count
  }
}
